import type { RefObject } from 'react'
import { useEffect } from 'react'

interface UseIntersectionObserverOptions extends Omit<IntersectionObserverInit, 'rootMargin' | 'threshold'> {
  onIntersect: (entry: IntersectionObserverEntry) => void
  rootMargin?: string
  threshold?: number[]
}

export function useIntersectionObserver(
  ref: RefObject<HTMLElement | null>,
  hideHeader: boolean,
  options?: UseIntersectionObserverOptions,
) {
  const { onIntersect, rootMargin, threshold, ...rest } = options || {}

  const defaultRootMargin = `${hideHeader ? '0px' : '-88px'} 0px 0px 0px`
  const observerOptions = {
    rootMargin: rootMargin || defaultRootMargin,
    threshold: threshold || [0],
    ...rest,
  }

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        onIntersect?.(entry)
      },
      observerOptions,
    )

    if (ref.current) {
      observer.observe(ref.current)
    }

    return () => observer.disconnect()
    // eslint-disable-next-line react/exhaustive-deps
  }, [])
}
